<template>
    <div
        v-if="additionalDataIsLoading || additionalData"
        class="i-results__wrapper" >
        <radio-tabs
            v-if="!isMobile"
            :tabs="tabs"
            @tabs-changed="tabSelected" />
        <simple-select
            v-if="isMobile && Object.values(tabs).length > 1"
            :items="tabs"
            @tab-selected="tabSelected" />
    </div>
    <h2
        v-if="title"
        class="i-results__table-title"
        :title="title"
        v-html="title"
    ></h2>
    <template v-if="tabsMatchTitle()">
        <template v-if="title === tabs.msfo">
            <template v-if="investorsDataIsLoading || investorsData">
                <results-tab :isLoading="investorsDataIsLoading" :data="investorsData?.data" :is-reverse="true"/>
            </template>
        </template>
        <template v-if="title === tabs.osbu">
            <template v-if="additionalDataIsLoading || additionalData">
                <results-tab :isLoading="additionalDataIsLoading" :data="additionalData?.data" :is-reverse="true" />
            </template>
        </template>
        <template v-if="title === tabs.year">
            <template v-if="yearDataIsLoading || yearData">
                <results-links :isLoading="yearDataIsLoading" :data="yearData?.data" />
            </template>
        </template>
    </template>
    <template v-else>
        <template v-if="investorsDataIsLoading || investorsData">
            <results-tab :isLoading="investorsDataIsLoading" :data="investorsData?.data" />
        </template>
    </template>
</template>

<script>
    import ResultsTab from './components/ResultsTab'
    import ResultsLinks from './components/ResultsLinks'
    import RadioTabs from './components/RadioTabs'
    import SimpleSelect from './components/SimpleSelect'
    import { investorsDataActionTypes } from '../store/modules/investors/investors'
    import { mapState } from 'vuex'

    export default {
        name: 'Results',
        components: {
            ResultsTab,
            ResultsLinks,
            RadioTabs,
            SimpleSelect
        },
        computed: {
            ...mapState({
                investorsDataIsLoading: state => state.investorsData.isLoading,
                investorsData: state => state.investorsData.data,
                investorsDataError: state => state.investorsData.error,
                additionalDataIsLoading: state => state.investorsData.additionalIsLoading,
                additionalData: state => state.investorsData.additional,
                additionalDataError: state => state.investorsData.additionalError,
                yearDataIsLoading: state => state.investorsData.yearIsLoading,
                yearData: state => state.investorsData.year,
                yearDataError: state => state.investorsData.yearError,
            }),
            isMobile () {
                return window.innerWidth < 768
            }
        },
        data() {
            return {
                apiUrl: '/api/v2/content/investors/',
                title: '',
                tabs: {
                    msfo: 'Отчётность по МСФО',
                    osbu: 'Отчётность ОСБУ',
                    year: 'Годовые отчёты'
                }
            }
        },
        methods: {
            tabSelected (val, name) {
                this.title = val
                history.pushState(null, null, `${window.location.origin}/investors/reports/${name}/`);
            },
            tabsMatchTitle() {
                let isFindMatch = false
                for (let tab in this.tabs) {
                    if (!isFindMatch && this.tabs[tab] === this.title) {
                        isFindMatch = true
                    }
                }
                return isFindMatch
            }
        },
        beforeMount() {
            const entry = document.querySelector('#app')
            const propsApi = entry.getAttribute('data-api')
            this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {apiUrl: this.apiUrl + propsApi})
            const additionalApi = entry.getAttribute('additional-api')
            if (additionalApi) {
                this.$store.dispatch(investorsDataActionTypes.getAdditionalData, {apiUrl: this.apiUrl + additionalApi})
                const location = window.location.pathname.split('/').filter(Boolean)
                this.title = this.tabs[location[location.length - 1]]
            }
            const yearApi = entry.getAttribute('year-api')
            if (yearApi) {
                this.$store.dispatch(investorsDataActionTypes.getYearData, {apiUrl: this.apiUrl + yearApi})
                const location = window.location.pathname.split('/').filter(Boolean)
                this.title = this.tabs[location[location.length - 1]]
            }
            const dataTitle = entry.getAttribute('data-title')
            if (dataTitle) {
                this.title = dataTitle
            }
        },
    }
</script>
